import { BaseModel } from "../../Bases/BaseModel";
import { UsuarioFiltroAcesso } from "./UsuarioFiltroAcesso";

export class Usuario extends BaseModel {
    constructor(
        public usuario = '',
        public senha = '',
        public usuario_id = '',
        public nome = '',
        public sobrenome = '',
        public email = '',
        public celular = '',
        public email_ratc = '',
        public email_nao_conformidade = '',
        public empresa_id = '',
        public nome_usuario = '',
        public link_painel_performance = '',
        public ip = '',
        public usuarioFiltroAcesso = new UsuarioFiltroAcesso(),
    ) {
        super();
    }
}

